'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onCalloutTypeChange", "onCalloutRemove"];
import PropTypes from 'prop-types';
import { PopoverBodyMode } from '../../constants/popover';
import CalloutPopoverBodyLite from './CalloutPopoverBodyLite';
import CalloutPopoverBodyEdit from './CalloutPopoverBodyEdit';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onCalloutTypeChange: PropTypes.func.isRequired,
  onCalloutRemove: PropTypes.func.isRequired
};
const defaultProps = {
  mode: PopoverBodyMode.PREVIEW
};
function CalloutPopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onCalloutTypeChange,
      onCalloutRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (mode === PopoverBodyMode.PREVIEW) {
    const handleEdit = () => {
      onModeChange(PopoverBodyMode.EDIT);
    };
    return /*#__PURE__*/_jsx(CalloutPopoverBodyLite, {
      onEdit: handleEdit,
      onRemove: onCalloutRemove
    });
  }
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  return /*#__PURE__*/_jsx(CalloutPopoverBodyEdit, Object.assign({}, rest, {
    onChange: onCalloutTypeChange,
    onClose: handleClose
  }));
}
CalloutPopoverBodyBranch.propTypes = propTypes;
CalloutPopoverBodyBranch.defaultProps = defaultProps;
CalloutPopoverBodyBranch.displayName = 'CalloutPopoverBodyBranch';
export default CalloutPopoverBodyBranch;